module.exports = __webpack_public_path__ + "static/media/so-stock--sheep2.52aefd30.jpg";